import { useState } from 'react'
import Cropper from 'react-easy-crop'

export default function ImageCropper({image, onComplete}) {
    const [crop, setCrop] = useState({ x: 0, y: 0 })
    const [zoom, setZoom] = useState(1)

    const onCropComplete = (croppedArea, croppedAreaPixels) => {
        onComplete(croppedArea, croppedAreaPixels)
    }

    return (
        <Cropper
            image={image}
            crop={crop}
            cropSize={{width: 204, height: 204}}
            zoom={zoom}
            aspect={4 / 3}
            onCropChange={setCrop}
            onCropComplete={onCropComplete}
            onZoomChange={setZoom}
            showGrid={false}
            objectFit="contain"
            // onMediaLoaded={(mediaSize) => {
            //     setZoom(CONTAINER_HEIGHT / mediaSize.naturalHeight)
            // }}
        />
    )
}
